import React, { useEffect, useState } from 'react'
import { FaCheckCircle } from 'react-icons/fa'
import { useTranslation } from 'react-i18next'
import { useHistory, useLocation } from 'react-router-dom'
import MoonLoader from 'react-spinners/MoonLoader'
import TagManager from 'react-gtm-module'
import { ROUTE_LOGIN } from '../constants'
import qs from 'query-string'


const RegisterSuccess = (props) => {
  const { t } = useTranslation('translation', { useSuspense: false })
  const history = useHistory()
  const location = useLocation()
  const userLogged = JSON.parse(localStorage.getItem('user'))
  const [from] = useState(qs.parse(location.search).from)

  if (!userLogged) {
    history.push(ROUTE_LOGIN)
  }

  useEffect(() => {
    TagManager.dataLayer({
      dataLayer: {
        event: 'asyncAction',
        gaHitType: 'event',
        category: 'Signup',
        action: 'Signup-Success',
        userId: userLogged.id,
        userType: userLogged.type,
        label: userLogged.socialType ? userLogged.socialType : 'onsite',
      }
    })
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  setTimeout(() => {    
    localStorage.removeItem("user");
    const pattern = /^((http|https|))/;
    window.location.href = from ? from : (userLogged.redirect && pattern.test(userLogged.redirect))
      ? decodeURIComponent(userLogged.redirect)
      : `${process.env.REACT_APP_WEBSITE_PATH}/${userLogged.redirect}`
  }, 4000)

  return (
    <div className='w-full flex flex-col items-center justify-center text-center p-4'>
      <i className='text-primary text-6xl my-4'><FaCheckCircle /></i>
      <span className='text-xl'>{t('registerSuccess')}</span>
      {/* reklame pixel */}
      {(userLogged && userLogged.type !== 'tenant') && (
        // eslint-disable-next-line jsx-a11y/alt-text
        <img src={`https://tracking.adgoon.it/SL1qB?adv_sub=${userLogged.id}`} width="1" height="1" className="hidden" />
      )}
      <MoonLoader
        size={36}
        color={'#439fa0'}
      />
    </div>
  )
}

export default RegisterSuccess